// removed by extract-text-webpack-plugin
module.exports = {"user-image":"user-image","image-default":"image-default","user-initials":"user-initials"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/user-image/user-image.style.sass
// module id = WnJf
// module chunks = 0